// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "vendors" + "-" + "22787ec2740e4123713f" + ".js";
};